import { MenuHeader } from '../../menu/menu-mobile/menu-header/menu-header';
import { createSignal } from 'solid-js';
import { LoginForm } from '../../login-form/login-form';
import { TabHandler } from '../../../tools/tab-handler';

type LoginMenuMobileProps = {
    handleCloseMenuClick: () => void;
    handleSignOutClick: () => void;
};

export const LoginMenuMobile = (props: LoginMenuMobileProps) => {
    // Accessibility/keyboard-controls related
    const [ firstTabbableElement, setFirstTabbableElement ] = createSignal<HTMLElement | undefined>();
    const [ lastTabbableElement, setLastTabbableElement ] = createSignal<HTMLElement | undefined>();

    return (
        <TabHandler
            refs={{
                firstTabbableElement,
                lastTabbableElement,
            }}
        >
            <div class="px-[1.57rem] pt-0 pb-0 z-10 overflow-y-scroll overflow-x-hidden max-[480px]:p-[1.14rem] max-[480px]:pt-0 max-[480px]:pb-0">

                <MenuHeader handleCloseMenuClick={props.handleCloseMenuClick} />

                <LoginForm
                    firstElement={(el: HTMLElement) => {
                        setFirstTabbableElement(el);
                    }}
                    lastElement={(el: HTMLElement) => {
                        setLastTabbableElement(el);
                    }}
                />
            </div>
        </TabHandler>
    );
};
